module.exports = __webpack_public_path__ + "static/media/finbit_admin_avatar.e65a5143.png";